import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { Archived } from "../../../../model/filters/archived";
import { Router } from "@angular/router";

@Component({
  selector: "archived-form",
  templateUrl: "./archived-form.component.html",
  styleUrls: ["./archived-form.component.css"],
})
export class ArchivedFormComponent {
  @Input() filter: Archived = new Archived();
  @Output() applyFilter = new EventEmitter<Archived>();

  constructor(private router: Router) {}

  apply(): void {
    this.applyFilter.emit(new Archived());
  }
}
